/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AccessTypeE {
    Opravneni = 'OPRAVNENI',
    SablonyVytvareni = 'SABLONY_VYTVARENI',
    Sablony = 'SABLONY',
    SablonySkupiny = 'SABLONY_SKUPINY',
    SablonySkupinyVytvareni = 'SABLONY_SKUPINY_VYTVARENI',
    OpravneniOvereni = 'OPRAVNENI_OVERENI',
    Reklamace = 'REKLAMACE',
    ReklamaceSpravce = 'REKLAMACE_SPRAVCE',
    StatistikyOkz = 'STATISTIKY_OKZ',
    StatistikySablony = 'STATISTIKY_SABLONY',
    StatistikyCertifikaty = 'STATISTIKY_CERTIFIKATY',
    ArchivaceOkz = 'ARCHIVACE_OKZ',
    ArchivaceSablony = 'ARCHIVACE_SABLONY',
    ArchivaceCertifikaty = 'ARCHIVACE_CERTIFIKATY',
    Certifikaty = 'CERTIFIKATY',
    CertifikatyOvereni = 'CERTIFIKATY_OVERENI',
    OpravneniUkonceni = 'OPRAVNENI_UKONCENI',
    ReklamaceImpl = 'REKLAMACE_IMPL',
    Ciselniky = 'CISELNIKY',
    CiselnikyEditace = 'CISELNIKY_EDITACE'
}

